import Vue from 'vue';
import Component from 'vue-class-component';
import StyleSlider from '../styleSlider/styleSlider';
import ColorPicker from '../colorPicker/colorPicker';
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Inject, Prop } from 'vue-property-decorator';
import { getSrtParamsStyleByArticleId, saveSrtParamsStyle } from '../../utils/srtParamsStyle';
import { debouncedSaveArticle } from '../../utils/utils';

@Component({
  components: {
    StyleSlider,
    ColorPicker
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class StyleContent extends Vue {
  @Prop({ default: '' })
  source?: string
  @Prop({ default: {} })
  subtitleInfo?: any
  @Inject({from: 'triggerEditorSubtitle'})
  triggerEditorSubtitle
  state = new PageState();
  colorVisible = false;
  // tablist
  tabList = ['文本', '背景']
  // 字体样式列表
  fontStyleList: any = [
    {
      fontColour: '',
      fontStrokeColor: '',
    },
    {
      fontColour: '#C4CD46',
      fontStrokeColor: '#4D601E',
    },
    {
      fontColour: '#FFFFFF',
      fontStrokeColor: '#000000',
    },
    {
      fontColour: '#000000',
      fontStrokeColor: '#ffffff',
    },
    {
      fontColour: '#FFE001',
      fontStrokeColor: '#000000',
    },
    {
      fontColour: '#FFFFFF',
      fontStrokeColor: '#FF8B84',
    },
    {
      fontColour: '#B8DFFC',
      fontStrokeColor: '#000000',
    },
    {
      fontColour: '#FED9E7',
      fontStrokeColor: '#F6669E',
    },
    {
      fontColour: '#BDF3F6',
      fontStrokeColor: '#4B9DE7',
    },
  ]
  // 模式列表
  modeList = [
    {
      id: 0,
      icon: 'images/video_editor/font_style0_icon.png',
      type: 'none'
    },
    {
      id: 1,
      icon: 'images/video_editor/text_bg1_mode.png',
      type: 'consummation'
    },
    // {
    //   id: 2,
    //   icon: 'images/video_editor/text_bg2_mode.png',
    //   type: 'outline'
    // }
  ]
  // 颜色列表
  colorList = ['#000000', '#CCCCCC', '#FCEFF9', '#FFE0F0', '#FF59A3', '#FF9899', '#FF6766', '#C81F32',
  '#FE653C', '#FE9900', '#FDCD0B', '#FFD362', '#FDDEA5', '#FFFF00', '#FBFFC2', '#C3D0B5', '#A7FC00', 
  '#C5C669', '#9AAB4F', '#24C752', '#55D0B4', '#669900', '#688D6C', '#9BC3CA', '#84D6FE', '#CDE9FF',
  '#E3F0FF', '#DCD7EB', '#B6BCD8', '#85A0CB', '#7F97D7', '#434CCD', '#8D72FF', '#CD66FF', '#8A2C9C',
  '#3D0067', '#473F34', '#55371D', '#3B1E32', '#451418', '#411F1D', '#223931', '#17221C', '#172A30']
  // 当前tab索引
  activeTabIndex = 0
  // 当前字体样式
  activeFontStyle = this.fontStyleList[4]
  // 当前模式
  acitveMode = this.modeList[0]
  // 当前颜色
  activeColor = '#ffffff'
  // 新-字体大小
  fontPercent = 8
  // 字体大小最大字号或者比例
  fontSizeMax = 16
  // 透明度
  alphaVal = 0.8
  colorPicker = null

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    this.initFontStyleList()
    this.$bus.$on(this.$EventBusKey.CHANGE_STYLE_CONTENT, this.changeStyleContent)
  }
  beforeDestory() {
    this.$bus.$off(this.$EventBusKey.CHANGE_STYLE_CONTENT, this.changeStyleContent)
  }
  get handleTableList() {
    if (this.source === 'cover') {
      return ['文本']
    }
    return ['文本', '背景']
  }
  get contentHeight() {
    if (this.source === 'text_template') {
      return '352px'
    }
    return this.state.styleContentHeight || '426px'
  }
  changeStyleContent() {
    if (!this.state.subtitleInfo) return
    const {fontColour, fontStrokeColor, bgMode, bgColor} = this.state.subtitleInfo
    if (fontColour) {
      const fontInfo = this.fontStyleList.find(item => item.fontColour === fontColour && 
        item.fontStrokeColor === fontStrokeColor)
      if (fontInfo) {
        this.activeFontStyle = fontInfo
      }
     const color = this.colorList.find(item => item === fontColour)
      if (color) {
        this.activeColor = color
      } else {
        this.activeColor = ''
      }
    }
    if(bgMode === 'consummation') {
      this.activeTabIndex = 1
      this.acitveMode = this.modeList[1]
      this.activeColor = bgColor
    } else {
      this.activeTabIndex = 0
      this.acitveMode = this.modeList[0]
      this.activeColor = ''
    }
  }
  /**
   * 初始化字体样式数据
   */
  initFontStyleList() {
    this.fontStyleList = this.fontStyleList.map((item, index) => {
      item.id = index
      item.icon = `/images/video_editor/font_style${index}_icon.png`
      return item
    })
    console.log('initFontStyleList-------', this.state.subtitleInfo.fontColour)
    if (this.source !== 'text_template') {
      this.fontSizeMax = 16
      if (this.subtitleInfo && this.subtitleInfo.fontColour) {
        const fontInfo = this.fontStyleList.find(item => item.fontColour === this.subtitleInfo.fontColour && item.fontStrokeColor === this.subtitleInfo.fontStrokeColor)
        if (fontInfo) {
          this.activeFontStyle = fontInfo
          this.selectFontStyle(fontInfo)
        }
       
      } else if (this.state.subtitleInfo.fontColour) {
        const fontInfo = this.fontStyleList.find(item => item.fontColour === this.state.subtitleInfo.fontColour && item.fontStrokeColor === this.state.subtitleInfo.fontStrokeColor)
        if (fontInfo) {
          this.activeFontStyle = fontInfo
          this.selectFontStyle(fontInfo)
        }
  
      } else {
        this.activeFontStyle = this.fontStyleList[4]
        this.selectFontStyle(this.activeFontStyle)
      }
      if (this.subtitleInfo.alpha !== undefined) {
        this.alphaVal = this.subtitleInfo.alpha
      }
      const colorListStr = localStorage.getItem('colorList')
      if (colorListStr) {
        this.colorList = JSON.parse(colorListStr)
      }
      const {bgMode, bgColor} = this.state.subtitleInfo
      if (bgMode === 'consummation' && bgColor) {
        this.acitveMode = this.modeList.find(item => item.type === 'consummation')
        this.activeTabIndex = 1
        this.$nextTick(() => {
          this.activeColor = bgColor
        })
       
      }
    } else {
      this.activeFontStyle = this.fontStyleList[0]
      if (this.state.operatingTextIndex !== undefined) {
        const operatingTextInfo = this.state.operatingTextList[this.state.operatingTextIndex]
        if (operatingTextInfo.backgroundColor) {
          this.acitveMode = this.modeList.find(item => item.type === 'consummation')
          this.activeTabIndex = 1
          this.$nextTick(() => {
            this.activeColor = operatingTextInfo.backgroundColor
          })
        }
        const fontInfo = this.fontStyleList.find(item => item.fontColour === operatingTextInfo.color && item.fontStrokeColor === operatingTextInfo.strokeColor)
        if (fontInfo) {
          this.activeFontStyle = fontInfo
          this.selectFontStyle(fontInfo)
        }
        if (operatingTextInfo.fontSize) {
          this.fontPercent = operatingTextInfo.fontSize
        }
        this.alphaVal = operatingTextInfo.opacity
      }
      this.fontSizeMax = 20
    }
  }
  /**
   * 添加颜色
   */
  addColor(color) {
    const index = this.colorList.findIndex(item => item === color)
    if (index === -1) {
      this.colorList.push(color)
      localStorage.setItem('colorList', JSON.stringify(this.colorList))
    }
  }
  /**
   * 选择字体样式
   */
  selectFontStyle(fontStyle) {
    this.activeFontStyle = fontStyle
    if (this.source === 'cover') {
      let info = {
        ...this.subtitleInfo,
        fontColour: fontStyle.fontColour,
        fontStrokeColor: fontStyle.fontStrokeColor
      }
      // if (fontStyle.fontStrokeColor) {
      //   info.fontStrokeWidth = 5 / 100 / 10
      // } else {
      //   info.fontStrokeWidth = 0
      // }
      this.triggerEditorSubtitle(info)
      this.$bus.$emit('input-subtitle', info)
    } else if (this.source === 'text_template') {
      // 文字模板
      if (this.state.operatingTextIndex !== undefined) {
        const operatingTextInfo = this.state.operatingTextList[this.state.operatingTextIndex]
        operatingTextInfo.color = fontStyle.fontColour
        operatingTextInfo.strokeColor = fontStyle.fontStrokeColor
      }
    } else {
      this.state.subtitleInfo.fontColour = fontStyle.fontColour
      this.state.subtitleInfo.fontStrokeColor = fontStyle.fontStrokeColor
      if (fontStyle.fontStrokeColor) {
        this.state.subtitleInfo.fontStrokeWidth = 5 / 100 / 10
      } else {
        this.state.subtitleInfo.fontStrokeWidth = 0
      }
      this.state.subtitleInfo.type = 1
      debouncedSaveArticle(this)
    }
    
   
  }
  /**
   * 选择tab
   */
  changeTab(index) {
    this.activeTabIndex = index
  }
  /**
   * 选择模式
   */
  selectMode(mode) {
    this.acitveMode = mode
   
    if (mode.type !== 'none') {
      this.selectColor(this.colorList[0])
    }
    if (this.source === 'cover') {
      let info = {...this.subtitleInfo, bgMode: mode.type, }
      this.triggerEditorSubtitle(info)
      this.$bus.$emit('input-subtitle', info)
    } else if (this.source === 'text_template') {
      // 文字模板

    } else {
      this.state.subtitleInfo.bgMode = mode.type
      this.state.subtitleInfo.type = 1
      debouncedSaveArticle(this)
    }
  }
  /**
   * 重置颜色
   */
  resetColor() {
    this.activeColor = ''
    if (this.source === 'cover') {
      let info = {
        ...this.subtitleInfo,
        bgMode: this.acitveMode.type
      }
      if (this.activeTabIndex === 0) {
        info = {...info, fontColour: '#ffffff'}
      } else {
        info = {...info, bgColor: this.colorList[0]}
      }
      this.$bus.$emit('input-subtitle', info)
      this.triggerEditorSubtitle(info)
    } else if (this.source === 'text_template') {
      // 文字模板
      if (this.state.operatingTextIndex !== undefined) {
        const operatingTextInfo = this.state.operatingTextList[this.state.operatingTextIndex]
        if (this.acitveMode.type === 'consummation' && this.activeTabIndex === 1) {
          operatingTextInfo.backgroundColor = 'transparent'
        } else if (this.activeTabIndex === 0) {
          operatingTextInfo.color = '#ffffff'
        }
      }
    } else {
      if (this.activeTabIndex === 0) {
        this.state.subtitleInfo.fontColour = this.activeFontStyle.fontColour
      } else {
        this.state.subtitleInfo.bgColor = this.colorList[0]
      }
      this.state.subtitleInfo.type = 1
    }
    
    
  }
  // openColorPicker() {
  //   this.colorVisible = true
  // }
  /**
   * 选择颜色
   */
  selectColor(color) {
    this.activeColor = color
    if (this.source === 'cover') {
      let info = {
        ...this.subtitleInfo,
        bgMode: this.acitveMode.type
      }
      if (this.activeTabIndex === 0) {
        info = {...info, fontColour: color}
      } else {
        info = {...info, bgColor: color}
      }
      this.triggerEditorSubtitle(info)
      this.$bus.$emit('input-subtitle', info)
    } else if (this.source === 'text_template') {
      // 文字模板
      if (this.state.operatingTextIndex !== undefined) {
        const operatingTextInfo = this.state.operatingTextList[this.state.operatingTextIndex]
       
        if (this.acitveMode.type === 'consummation' && this.activeTabIndex === 1) {
          operatingTextInfo.backgroundColor = color
        } else if (this.activeTabIndex === 0) {
          operatingTextInfo.color = color
        }
        console.log('acitveMode', this.acitveMode)
      }
    } else {
      if (this.activeTabIndex === 0) {
        this.state.subtitleInfo.fontColour = color
      } else {
        this.state.subtitleInfo.bgColor = color
      }
      this.state.subtitleInfo.type = 1
      debouncedSaveArticle(this)
    }
   
  }
  /**
   * 更改值
   */
  changeSlider(type, val) {
    if (this.source === 'cover') {
      let info = {
        ...this.subtitleInfo,
        bgMode: this.acitveMode.type
      }
      if (type === 'fontPercent') {
        info = {...info, fontPercent: this.fontPercent}
      } else {
        if (this.activeTabIndex === 0) {
          info = {...info, alpha: val}
        } else {
          info = {...info, bgAlpha: val}
        }
      }
      this.triggerEditorSubtitle(info)
      this.$bus.$emit('input-subtitle', info)
    } else if (this.source === 'text_template') {
      // 文字模板
      if (this.state.operatingTextIndex !== undefined) {
        const operatingTextInfo = this.state.operatingTextList[this.state.operatingTextIndex]
        console.log('changeSlider', type)
        if (type === 'fontPercent') {
          operatingTextInfo.fontSize = val
        } else {
          operatingTextInfo.opacity = val
        }
      }
    } else {
      if (type === 'fontPercent') {
        this.state.subtitleInfo.fontPercent = this.fontPercent
        saveSrtParamsStyle({
          fontPercent: this.fontPercent
        })
      } else {
        if (this.activeTabIndex === 0) {
          this.state.subtitleInfo.alpha = val
          saveSrtParamsStyle({
            alpha: val
          })
        } else {
          this.state.subtitleInfo.bgAlpha = val
          saveSrtParamsStyle({
            bgAlpha: val
          })
        }
      }
      debouncedSaveArticle(this)
    }
    
    this.state.subtitleInfo.type = 1

  }
  openColorPicker() {
    this.colorVisible = true
  }
  /**
   * 关闭颜色选择器
   */
  closeColorPicker() {
    this.colorVisible = false
  }
}